/**
 * Export Configuration
 * Centralized configuration for export functionality
 */

export const EXPORT_FORMATS = {
  STL: 'stl',
  PLY: 'ply',
  OBJ: 'obj'
};

export const EXPORT_CONFIG = {
  defaultFormat: EXPORT_FORMATS.STL,

  formats: {
    [EXPORT_FORMATS.STL]: {
      extension: '.stl',
      mimeType: 'application/octet-stream',
      label: 'STL Format',
      preservesColor: false,
      description: 'Binary STL (smaller file size)'
    },
    [EXPORT_FORMATS.PLY]: {
      extension: '.ply',
      mimeType: 'text/plain',
      label: 'PLY Format',
      preservesColor: true,
      description: 'PLY with vertex colors'
    },
    [EXPORT_FORMATS.OBJ]: {
      extension: '.obj',
      mimeType: 'model/obj',
      label: 'OBJ Format',
      preservesColor: true,
      description: 'Wavefront OBJ + MTL (companion file download)'
    }
  },

  // Default filename pattern
  defaultFileName: 'socket',

  // Enable/disable color preservation
  preserveColors: true
};

/**
 * Get export format configuration
 * @param {string} format - Export format (stl or ply)
 * @returns {Object} Format configuration
 */
export function getFormatConfig(format) {
  return EXPORT_CONFIG.formats[format] || EXPORT_CONFIG.formats[EXPORT_CONFIG.defaultFormat];
}

/**
 * Get all available export formats
 * @returns {Object} All format configurations
 */
export function getAllFormats() {
  return EXPORT_CONFIG.formats;
}

/**
 * Generate download filename with timestamp
 * @param {string} baseName - Base filename
 * @param {string} format - Export format
 * @returns {string} Complete filename with extension
 */
export function generateFileName(baseName = EXPORT_CONFIG.defaultFileName, format = EXPORT_CONFIG.defaultFormat) {
  const timestamp = new Date().toISOString().split('T')[0]; // YYYY-MM-DD
  const formatConfig = getFormatConfig(format);
  return `${baseName}_${timestamp}${formatConfig.extension}`;
}
